import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import * as actions from 'store/actions';
import { faUser, faSignInAlt } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as cTypes from 'Flow2/components/AdvancedBox/AdvancedConfig/ConfigTypes';
import "./SignUp.scss";

const SignUp = (props) => {
    const [userInputs, setUserInputs] = useState({});
    const [errors, setErrors] = useState({});
    const [data, setData] = useState(cTypes.SIGNUP_ITEMS);

    const fm = (id) => props.intl.formatMessage({ id });

    useEffect(() => {
        if (props.data) setData(props.data);
    }, [props.data]);

    const handleSignUp = (e) => {
        e.preventDefault();
        if ((errors && Object.keys(errors).some(item => errors[item]))) {
            console.log("LOGS: handleSignUp errors", errors);
        } else {
            props.onClose();
        }
    }

    const onInput = ({ e, item }) => {
        const { value } = e.target;
        let isValid = true;
        if (item.isRequired) {
            if (!value || !value.trim()) setErrors({ ...errors, [item.name]: true });
            else setErrors({ ...errors, [item.name]: false });
        }
        if (item && item.rules && props.checkValidity) {
            isValid = props.checkValidity(value, item.rules);
            if (!isValid) setErrors({ ...errors, [item.name]: true });
            else setErrors({ ...errors, [item.name]: false });
        }
        setUserInputs((prev) => {
            return ({ ...prev, [item.name]: value || '' });
        });
    }

    const getHeadline = () => {
        let txt = fm('login.signup');
        if (props.heading) txt = props.heading;
        let img = <FontAwesomeIcon icon={faUser} />;
        if (props.logo) img = <img src={props.logo} />
        return (
            <h1 className="signup-heading">
                {img}
                {txt}
            </h1>
        )
    }

    const getSubTxt = () => {
        if (props.subtxtItems) {
            return props.subtxtItems.map(item => {
                return (<div>{fm(item.intl)}</div>)
            })
        }
        return null;
    }

    const showLogin = () => {
        const txt = fm('app.loginTitle');
        let login = <Link to={"/login"} className='signup-link'>{txt}</Link>;
        if (props.withLoginBtn) {
            login = <div className="signup-login" onClick={() => props.onClose()}>{txt}</div>;
        }
        return (
            <div className="signup-member">
                {fm("auth.already.member")}? {" "}
                {login}
            </div>
        )
    }

    return (
        <div className="signup-hero-bg">
            <div className="signup-box">
                <div className="signup-wrapper">
                    <div className="signup-top">
                        {getHeadline()}
                        <div className="signup-subtxt">
                            {getSubTxt()}
                        </div>
                    </div>
                    <form className="signup-form" onSubmit={handleSignUp}>
                        {data.map((item, i) => (
                            <div className="signup-group" key={`signuppage-${i}${item.name}`}>
                                <label htmlFor={item.name} className="signup-label">{fm(item.intl)}</label>
                                <input className={`signup-input ${errors[item.name] ? ' signup-red' : ''}`}
                                    placeholder={item.placeholder ? item.placelholder : fm(item.intl)}
                                    required={item.isRequired} id={item.name} onChange={(e) => onInput({ e, item })}
                                    value={userInputs[item.name]} type={item.type} />
                            </div>
                        ))}
                        <button className="signup-btn">
                            <FontAwesomeIcon icon={faSignInAlt} />
                            {fm('page.auth.link.register')}
                        </button>
                        {showLogin()}
                    </form>
                </div>
            </div>
        </div>
    )
}

const mapStateToProps = (state) => ({
    // authObjects: state.auth.authObjects,
});

const mapDispatchToProps = (dispatch) => ({
    // updateAuthObjects: (obj) => dispatch(actions.updateAuthObjects(obj)),
});

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(SignUp));
